import { getSupervisorReceiptConfigurationStore } from "../../../../stores/supervisor-store/supervisor-receipt-configuration-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const SupervisorReceiptConfigurationForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      onClick={async () => {
        getSupervisorReceiptConfigurationStore().showReceiptConfigutationDashboard.set(
          true
        );
        await getSupervisorReceiptConfigurationStore().getReceiptConfigutationData();
      }}
      isEnabled={true}
      size="LARGE"
      text="GET"
      type="GET"
    />
  );
});
export default SupervisorReceiptConfigurationForm;
